import lf from "localforage";
import msg from "../../common/msg";
// import fileutility from "./fileutility";

const lf_files_keys = lf.createInstance({name: "wip_localfiles-keys"});
const lf_files_data = lf.createInstance({name: "wip_localfiles_data"});
const lf_data_to_update = lf.createInstance({name: "wip_data_to_update"});
const lf_data_image_upload = lf.createInstance({name: "wip_image_upload_data"});
const lf_data_image_files = lf.createInstance({name: "wip_image_upload_files"});

const promises = {};

if (navigator.serviceWorker) {
	navigator.serviceWorker.addEventListener("message", (event) => {
		// event is a MessageEvent object
		let data = event.data;
		// console.log(`The service worker sent me a message: ${data}`);

		let rnf = JSON.parse(event.data);

		// console.log({rnf});

		if (rnf.nf) {
			let nf = rnf.nf;
			let result = JSON.parse(rnf.result.d);

			if (promises[nf]) {
				let callback = promises[nf];
				delete promises[nf];
				if (callback) callback(result);
			}
		}
	});
}

const WorkerFunctions = () => {
	return {
		UploadFilesOffline: (uuid, nf, imgs) => {
			lf_data_image_upload.setItem(uuid, {nf, imgs});
			lf_data_image_upload.getItem("queue", (queue) => {
				if (!queue) queue = [];
				queue.push(uuid);
				lf_data_image_upload.setItem("queue", queue);
			});

			lf_data_image_files.getItem("count").then((c) => {
				if (!c) c = 0;
				c += imgs.length;
				lf_data_image_files.setItem("count", c);
			});

			msg.ask("restartfileuploadprocesses", {}, "ts3");
			// console.log("worker manager", {imgs});
			// lf_data_image_upload.getItem(nf).then((existing) => {
			// 	if (!existing) existing = {imgs: []};
			// 	existing = [...existing.imgs, ...imgs];
			// 	lf_data_image_upload.setItem(nf, {imgs, links});
			// });
		},
		UpdateField: (nf, url, data, callback) => {
			promises[nf] = callback;
			lf_data_to_update.setItem(nf, {url, data});
		},
		UpdateFile: (nf, id, data) => {
			console.log("UpdateFile", {nf, id, data});
			lf_files_data.setItem(`${nf}-${id}`, data);
		},
		UpdateFiles: (nf, keys, links, value, callback) => {
			console.log("UpdateFiles", {nf, keys, links, value, callback});
			promises[nf] = callback;
			// console.log({nf, keys, links});
			lf_files_keys.setItem(nf, {keys, links, value}).then((_) => {
				// console.log("done");
			});
		},
		NewFileUpdate: (files, links, nf) => {
			console.log("NewFileUpdate", {files, links, nf});
			ConvertFilesToBase64(files).then((base64s) => {});

			// let keys = [];
			// Promise.all(
			// 	Object.keys(files).map((k) => {
			// 		return new Promise((resolve) => {
			// 			let f = files[k];
			// 			keys.push({name: f.name, id: f.id, type: f.type});
			// 			var reader = new FileReader();
			// 			reader.readAsDataURL(f.data);
			// 			reader.onloadend = function () {
			// 				var base64data = reader.result;
			// 				newB64s.push({
			// 					caption: f.name,
			// 					url: base64data,
			// 				});
			// 				workermanager.UpdateFile(v.attrs.nf, f.id, base64data);
			// 				// console.log({newB64s});
			// 				resolve();
			// 			};
			// 		});
			// 	})
			// ).then((_) => {
			// 	workermanager.UpdateFiles(v.attrs.nf, keys, v.attrs.links, v.attrs.value, (r) => {
			// 		// onchange(r);
			// 	});
			// 	// console.log("updaing entries", v.attrs.links, newB64s);
			// 	if (v.attrs.links) newB64s = [...v.attrs.links, ...newB64s];
			// 	// console.log("updated entries", {newB64s});
			// 	if (v.attrs.onchange) v.attrs.onchange(newB64s);
			// });
		},
	};
};

async function ConvertFilesToBase64(files) {
	let base64s = {};
	await Promise.allSettled(
		Object.keys(files).map((k) => {
			return new Promise((r) => {
				let f = files[k];
				let reader = new FileReader();
				reader.readAsDataURL(f.data);
				reader.onloadend = function () {
					var base64data = reader.result;
					base64s[k] = {
						caption: f.name,
						url: base64data,
					};
					r();
				};
			});
		})
	);
	return base64s;
}
const functions = WorkerFunctions();

export default functions;
